import { useTranslation } from 'hooks/translations/useCustomTranslation';
import React, { useState } from 'react';



import { ModalProps } from '@mui/material/Modal';



import Box from '../Box';
import { CustomIcon } from '../CustomIcon/CustomIcon';
import Modal from '../Modal';
import styles from './InfoPopup.module.scss';
import {SxProps} from "@mui/material";


interface ExtendedModalProps extends Omit<ModalProps, 'open'> {
  trigger: React.ReactNode;
  sx?: SxProps;
  stopPropagation?: boolean;
}

const InfoPopup: React.FC<ExtendedModalProps> = ({trigger, sx, children, stopPropagation, ...rest}): JSX.Element => {
  const {t} = useTranslation('loginModal');

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Box sx={{cursor: 'pointer', ...sx}} onClick={(e) => {
        if (stopPropagation){
          e.stopPropagation()
        } 
        setIsOpen(true);
      }}>
        {trigger}
      </Box>
      <Modal open={isOpen} onClick={e => {
        if (stopPropagation) {
          e.stopPropagation();
        } 
      }} onClose={(_e) => {
        setIsOpen(false)
        }} {...rest}>
        <Box className={styles.modalWrapper}>
          <Box className={styles.content}>{children}</Box>
          <button
            aria-label={t('closeModal')}
            type="button"
            onClick={e => {
              if (stopPropagation) {
                e.stopPropagation();
              } 
              e.preventDefault(), setIsOpen(false);
            }}
            className={styles.closeButton}
          >
            <CustomIcon name="close" className={styles.icon} />
          </button>
        </Box>
      </Modal>
    </>
  );
};

export default InfoPopup;